<div class="container-xxl">
  <div class="authentication-wrapper authentication-basic container-p-y">
    <div class="authentication-inner">
      <!-- Register Card -->
      <div class="card">
        <div class="card-body">
          <form [formGroup]="form" class="mb-3">
            <div class="mb-3">
              <label for="username" class="form-label">Full Name</label>
              <input type="text" class="form-control" formControlName="UserName" placeholder="Enter your first and last name (e.g., John Doe)"
                autofocus (keydown)="onKeyDown($event)" />
              <small class="form-text text-muted">Please enter your first and last name separated by a space</small>
            </div>
            <div class="mb-3">
              <label for="email" class="form-label">Email</label>
              <input type="text" class="form-control" placeholder="Enter your email" formControlName="Email" (keydown)="onKeyDown($event)" />
            </div>
            <div class="mb-3 form-password-toggle">
              <label class="form-label" for="password">Password</label>
              <div class="input-group input-group-merge">
                <input type="password" class="form-control" formControlName="Password"
                  placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                  aria-describedby="password" (keydown)="onKeyDown($event)" />

                <span class="input-group-text cursor-pointer" (click)="togglePasswordVisibility()">
                  <i class="bx" [ngClass]="showPassword ? 'bx-show' : 'bx-hide'"></i>
                </span>



              </div>
            </div>

            <div class="mb-3">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" formControlName="Terms" />
                <label class="form-check-label" for="terms-conditions">
                  I agree to
                  <a href="javascript:void(0);">privacy policy & terms</a>
                </label>
              </div>
            </div>


            <button class="btn btn-success d-grid w-100" (click)="onSubmit()">Sign up</button>
          </form>

          <p class="text-center">
            <span>Already have an account?</span>
            <a routerLink="/login">
              <span> Sign in instead</span>
            </a>
          </p>
        </div>
      </div>
      <!-- Register Card -->
    </div>
  </div>
</div>